import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import StudentCourseProgress, {
  SimplifiedCourseProgress,
} from '@/models/StudentCourseProgress';
import { BaseFilters } from '@/models/Service';
import { Course, CourseFormatEnum } from '@/models/Course';
import { EnrollmentStatusEnum } from '@/models/Enrollment';
import { ProgressStatusEnum } from '@/enums/ProgressStatusEnum';

export type ListCourseProgressFilters = BaseFilters & {
  klassId?: number;
  coursePathId?: number;
  coursePathSlug?: string;
  isActive?: boolean;
  student?: number;
  courseLineId?: number[];
  startSoon?: boolean;
  search?: string;
  courseFormats?: CourseFormatEnum[];
  exCourseFormats?: CourseFormatEnum[];
  ordering?: 'created_at' | '-created_at';
  progressMin?: number;
  progressMax?: number;
  enrollmentStatus?: EnrollmentStatusEnum[];
  status?: ProgressStatusEnum;
};

export const listSimplifiedCourseProgressByUserId = async (
  studentId: number,
  params: ListCourseProgressFilters = {},
) => {
  const { data } = await requester().get<
    JsonApiResponse<SimplifiedCourseProgress>
  >(`students/${studentId}/progress/`, {
    params,
  });
  return data;
};

export const listCourseProgresses = async (
  params: ListCourseProgressFilters = {},
) => {
  const { data } = await requester().get<
    JsonApiResponse<StudentCourseProgress>
  >(`course-progress/`, {
    params,
  });
  return data;
};

export async function listNextSteps(courseProgressId: number) {
  const { data } = await requester().get<JsonApiResponse<Course>>(
    `course-progress/${courseProgressId}/next-steps/`,
  );

  return data;
}

export const getSimplifiedCourseProgress = async (
  studentId: number,
  courseProgressId: number,
) => {
  const { data } = await requester().get<SimplifiedCourseProgress>(
    `students/${studentId}/progress/${courseProgressId}/`,
  );
  return data;
};
